import {useState, useEffect} from "react";
import {MiniEvent, subscribeToDescriptionEvents, useGlobalKeyPress} from "@cdx/common";
import {sortBy} from "es-toolkit/compat";
import {Col, Row, Text, DSCallout, DSShortcutKey} from "@cdx/ds";
import {completeOnboardingStep, ONBOARDING_STEPS} from "../features/onboarding/onboarding-utils";
import {DefaultLayoutModal} from "./Modal/DefaultLayoutModal";
import {useModalWithData} from "./Modal/Modals";

const keyToLabel = {
  " ": "Space",
};

const ShortcutEntry = ({keys, category}) => (
  <Col sp="16px" py="24px">
    <Row sp="12px">
      <div style={{width: 80}} />
      <Text type="label11Caps" color="secondary">
        {category}
      </Text>
    </Row>
    <Col sp="8px">
      {sortBy(keys, (k) => k[0]).map(([k, description]) => (
        <Row key={k} align="baseline" sp="12px">
          <Col align="end" style={{minWidth: 80}}>
            <DSShortcutKey>{keyToLabel[k] || k}</DSShortcutKey>
          </Col>
          <Text type="prose14" color="secondary">
            {description}
          </Text>
        </Row>
      ))}
    </Col>
  </Col>
);

const ShortcutList = ({currentKeys}) => {
  const categories = {
    General: [["Esc", "Closes active panel"]],
  };
  Object.entries(currentKeys).forEach(([k, v]) => {
    if (v.length > 0) {
      const last = v[v.length - 1];
      const cat = last.category;
      (categories[cat] = categories[cat] || []).push([k, last.description]);
    }
  });
  const sorted = sortBy(Object.keys(categories), (c) => (c === "General" ? "0" : c.toLowerCase()));
  return (
    <Col divideX>
      {sorted.map((c) => (
        <ShortcutEntry key={c} category={c} keys={categories[c]} />
      ))}
    </Col>
  );
};

const ShortcutModal = ({currentKeys}) => {
  useEffect(() => {
    completeOnboardingStep(ONBOARDING_STEPS.investigateShortcutPanel);
  }, []);

  return (
    <DefaultLayoutModal title="Available Shortcuts">
      <Col sp="24px" px="24px" py="12px">
        <DSCallout>
          This is a list of all available shortcuts for the current screen. Open this menu on a
          different screens to see more shortcuts.
        </DSCallout>
        <ShortcutList currentKeys={currentKeys} />
      </Col>
    </DefaultLayoutModal>
  );
};

const openEvents = new MiniEvent();
export const setOpen = (val) => openEvents.emit(val);

const ShortcutLister = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentKeys, setKeys] = useState({});

  useEffect(() => {
    return openEvents.addListener(setIsOpen);
  }, []);

  useEffect(() => {
    return subscribeToDescriptionEvents(setKeys);
  }, []);

  useGlobalKeyPress({
    key: "?",
    fn: () => setOpen((prev) => !prev),
    description: "Toggle this shortcut panel",
  });

  const renderModal = useModalWithData(isOpen, {onClose: () => setIsOpen(false), width: 500});
  return renderModal(() => <ShortcutModal currentKeys={currentKeys} />);
};

export default ShortcutLister;
